export default __webpack_public_path__ + "static/char-s-54-en-1ad8eafee2dd90ac97f24eba6f006ff9.png";